import { Link } from 'react-router-dom';
import { Button } from '../components/ui.jsx';
import BrandMark from '../components/BrandMark.jsx';

export default function NotFound() {
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24, position: 'relative', zIndex: 1 }}>
      <div className="center anim-up" style={{ maxWidth: 460 }}>
        <BrandMark size={40} className="mx-auto" />
        <div className="label">Error 404</div>
        <h1 className="mt-8">That dock door is empty</h1>
        <p className="muted mt-12">The page you were looking for isn’t on the board.</p>
        <div className="row gap-12 mt-20" style={{ justifyContent: 'center' }}>
          <Link to="/app"><Button variant="primary">Back to dashboard</Button></Link>
          <Link to="/"><Button variant="outline">Public site</Button></Link>
        </div>
      </div>
    </div>
  );
}
